/* eslint-disable no-unused-vars */
import React from 'react';
import style from './tagsPageContainer.module.scss';
import cx from 'classnames';
import { Tag, Tags } from 'store/types';
import map from 'lodash-es/map';
import MemoChip from 'components/memoChip/memoChip';
import ContextActionsComponent from 'controls/contextActions/contextActions';
import { useEditHandler } from 'hooks/tagActionHandlers/useEditHandler';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'store/hooks';
import { selectRole } from 'store/auth/authSlice';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { DURATIONS } from 'utils/utils';

export default function TagsPageContainer({
  className,
  tags,
  isBlockAnime = false,
}: {
  className?: string;
  tags?: Tags | Tag[];
  isBlockAnime?: boolean;
}) {
  // Может принять готовые компоненты, а может создать стандартные
  const editHandler = useEditHandler();
  const navigate = useNavigate();
  const role = useAppSelector(selectRole);

  return (
    <TransitionGroup
      className={cx(style.container, className)}
      component={'div'}
      exit={isBlockAnime ? false : true}
      enter={isBlockAnime ? false : true}
    >
      {tags
        ? map(tags, (tag: Tag) => {
            return (
              <CSSTransition
                timeout={DURATIONS.TAGS_ACTIONS}
                classNames="tagsActions-tg"
                key={tag.name + tag.amount}
              >
                <MemoChip
                  tag={tag}
                  className={style.cloudTag}
                  onClick={() => {
                    navigate(`/mapping?&tags=${tag.name}`, {
                      replace: false,
                    });
                  }}
                  endIcon={
                    role === 'admin' ? (
                      <ContextActionsComponent
                        actions={[
                          {
                            type: 'edit',
                            handler: editHandler.bind(null, {
                              contextItem: tag,
                            }),
                          },
                        ]}
                        iconType="tags"
                      ></ContextActionsComponent>
                    ) : (
                      ''
                    )
                  }
                  isAmountEnabled
                ></MemoChip>
              </CSSTransition>
            );
          })
        : []}
    </TransitionGroup>
  );
}
